module.exports = __webpack_public_path__ + "static/media/pizza_cf.11ccafeb.png";